export default __webpack_public_path__ + "static/media/90s_popup_bg@3x.ddcf905d.png";